export default [
    {
        path: '/pages/user/shopVipUser',
        name: '/pages/user/shopVipUser',
        component: () => import('@/views/user/shopVipUser.vue')
    },
    {
        path: '/pages/user/vipDetail',
        name: '/pages/user/vipDetail',
        component: () => import('@/views/user/vipDetail.vue')
    },
    {
        path: '/pages/user/adminShopVip',
        name: '/pages/user/adminShopVip',
        component: () => import('@/views/user/adminShopVip.vue')
    },
    {
        path: '/pages/user/mallUser',
        name: '/pages/user/mallUser',
        component: () => import('@/views/user/mallUser.vue')
    },
    {
        path: '/pages/user/mallUserDetail',
        name: '/pages/user/mallUserDetail',
        component: () => import('@/views/user/mallUserDetail.vue')
    },
    {
        path: '/pages/user/shopVipLevel',
        name: '/pages/user/shopVipLevel',
        component: () => import('@/views/user/shopVipLevel.vue')
    }
] 